import React, { Component } from 'react';
import { Helmet } from "react-helmet";
//import { Helmet } from 'react-helmet';

//<Helmet>
  //<script type="application/javascript">var UC_UI_SUPPRESS_CMP_DISPLAY=true;</script>
//</Helmet>

class About extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="container">
        <Helmet>
          <title>Impressum | Immovestics</title>
          <meta name="description" content="Unser Impressum" />
        </Helmet>

        <div className="row">
          <div className="col s12">


            <h1>Impressum</h1>

            <p>Relatively Unique GmbH<br />
Danziger Straße 4/1<br />
70825 Korntal-Münchingen</p>

            <p>Handelsregister: HRB 760374<br />
Registergericht: Amtsgericht Stuttgart</p>

            <p><strong>Vertreten durch:</strong><br />
Dr. Alexander Schick</p>

            <h2>Kontakt</h2>
            <p>Telefon: 0173 8466699<br />
E-Mail: kontakt@relativelyunique.com</p>

            <h2>Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
DE815702942</p>

            <h2>Redaktionell Verantwortlicher</h2>
            <p>Dr. Alexander Schick<br />
Danziger Straße 4/1<br />
70825 Korntal-Münchingen</p>

            <h2>EU-Streitschlichtung</h2>
            <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>

            <h2>Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h2>
            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

            <h3>Haftung für Inhalte</h3> <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p> <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p> <h3>Haftung für Links</h3> <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p> <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p> <h3>Urheberrecht</h3> <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p> <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>




            <h1>Credits</h1>

            <h2>Logo</h2>
            <p>
              Ich habe mein kostenloses Logo auf <a href={"https://logomakr.com/"} target="_blank" rel="noreferrer">LogoMakr.com</a> erstellt.
            </p>

            <h2>Bilder</h2>
            <h6>Startseite</h6>
            <p>
              Hochhaus Bild auf Startseite von <a href="https://pixabay.com/de/users/michaelgaida-652234/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=1727807" target="_blank" rel="noreferrer">MichaelGaida</a> auf <a href="https://pixabay.com/de/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=1727807" target="_blank" rel="noreferrer">Pixabay</a>
              <br></br>
              Architekturbild auf Startseite von <a href="https://pixabay.com/de/users/free-photos-242387/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=846087" target="_blank" rel="noreferrer">Free-Photos</a> auf <a href="https://pixabay.com/de/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=846087" target="_blank" rel="noreferrer">Pixabay</a>
              <br></br>
              Münzstapel Bild auf Startseite von <a href="https://pixabay.com/de/users/kschneider2991-4936815/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=2180330" target="_blank" rel="noreferrer">Kevin Schneider</a> auf <a href="https://pixabay.com/de/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=2180330" target="_blank" rel="noreferrer">Pixabay</a>
              <br></br>
              High Angle Photography of Village von <a href="https://www.pexels.com/@pixabay" target="_blank" rel="noreferrer">Pixabay</a> auf <a href="https://www.pexels.com/photo/aerial-view-architecture-autumn-cars-280221/" target="_blank" rel="noreferrer">Pexels</a>
            </p>

            <h6>Newsletter Seite</h6>
            <p>

            </p>

          </div>
        </div>
      </div>
    )
  }
}

export default About;
